import { useModal } from "@ebay/nice-modal-react";
import "./VariableEdition.css";
import { useBotStateContext } from "/src/features/editor/contexts/BotContext";
import Dropdown from "../../../../../../components/UI/DropDown/DropDown";
import TextInput from "/src/components/UI/TextField/TextInput";
import Button from "/src/components/UI/Button/Button";
import DataVariables from "/src/data/dropdown/variables";
import { useForm } from "react-hook-form";

// Popup use to create or modificate a variable name / type
function VariableEdition({ onClose }) {
    const { variables } = useBotStateContext();
    const modal = useModal();
    const { register, getValues, formState, setValue } = useForm({ mode: "onChange" });

    const onClick = () => {
        // ! important to resolve the value, api's call are declared in another component
        modal.resolve(getValues());
        return onClose();
    };

    return (
        <form className="variables_modal">
            <label className="title">Create a Variable</label>
            <div className="area-edit">
                <TextInput
                    {...register("name", {
                        required: true,
                        setValueAs: (v) => v.toLowerCase(),
                        validate: (v) =>
                            variables.filter((variable) => variable.name == v).length == 0 &&
                            /[^a-zA-Z0-9_]/.test(v) == false,
                    })}
                    className={`variable_input ${Object.keys(formState.errors).length && formState.errors.name.type == "validate" ? " error" : ""}`}
                    placeholder="Variable name"
                />
                <Dropdown {...register("type")} setValue={setValue} choices={DataVariables} width={250} />
            </div>
            <Button label="Confirm" onClick={onClick} disabled={!formState.isValid} />
        </form>
    );
}

export default VariableEdition;
